function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 55,
  y: 47,
  width: 440,
  height: 128,
  rx: 4,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_11_2337)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55 50.5H54.5V51V175V175.5H55H275H275.5V175V168.512V168.012H275H264.314V165.005V164.505H263.814H256.545V139.055V138.555H256.045H239.455V133.795V133.295H238.955H177.308V130.463V129.963H176.808H123.551V127.658V127.158H123.051H100.867V110.123V109.623H100.367H88.1271V92.589V92.089H87.6271H75.387V89.0822V88.5822H74.887H59.2288V51V50.5H58.7288H55Z",
  fill: "url(#paint0_linear_11_2337)",
  stroke: "url(#paint1_linear_11_2337)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M275 175.5H274.5V175V171.339V170.839H275H285.686V169.361V168.861H286.186H293.455V154.719V154.219H293.955H310.545V151.751V151.251H311.045H372.692V139.302V138.802H373.192H396.312V137.719V137.219H396.812H449.133V134.872V134.372H449.633H461.873V124.979V124.479H462.373H474.613V123V122.5L475.113 122.5L495 122.5L495.5 122.5V123V175V175.5H495H275Z",
  fill: "url(#paint2_linear_11_2337)",
  stroke: "url(#paint3_linear_11_2337)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.031 47V175",
  stroke: "url(#paint4_linear_11_2337)",
  strokeDasharray: "2 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 348.031,
  y: 147,
  width: 8,
  height: 8,
  rx: 4,
  fill: "url(#paint5_linear_11_2337)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211.088 47V175",
  stroke: "url(#paint6_linear_11_2337)",
  strokeDasharray: "2 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 207.088,
  y: 129,
  width: 8,
  height: 8,
  rx: 4,
  fill: "url(#paint7_linear_11_2337)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_11_2337)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 234,
  y: 81,
  width: 82,
  height: 40,
  rx: 4,
  fill: "#272A2E"
}), /*#__PURE__*/React.createElement("rect", {
  x: 234.5,
  y: 81.5,
  width: 81,
  height: 39,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.08
})), /*#__PURE__*/React.createElement("rect", {
  x: 257,
  y: 90,
  width: 49,
  height: 8,
  rx: 4,
  fill: "white",
  fillOpacity: 0.06
}), /*#__PURE__*/React.createElement("rect", {
  x: 257,
  y: 104,
  width: 49,
  height: 8,
  rx: 4,
  fill: "white",
  fillOpacity: 0.06
}), /*#__PURE__*/React.createElement("rect", {
  x: 244,
  y: 90,
  width: 8,
  height: 8,
  rx: 4,
  fill: "url(#paint8_linear_11_2337)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 244,
  y: 104,
  width: 8,
  height: 8,
  rx: 4,
  fill: "url(#paint9_linear_11_2337)"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_11_2337",
  x: 186,
  y: 33,
  width: 178,
  height: 136,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11_2337"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11_2337",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_11_2337",
  x1: 165.389,
  y1: 47,
  x2: 165.76,
  y2: 199.499,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.275901,
  stopColor: "#01AF92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1D1F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_11_2337",
  x1: 275,
  y1: 114.676,
  x2: 55,
  y2: 114.676,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AF92"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_11_2337",
  x1: 385,
  y1: 89.2703,
  x2: 385,
  y2: 188,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.342869,
  stopColor: "#FE500D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1D1F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_11_2337",
  x1: 275,
  y1: 149.703,
  x2: 495,
  y2: 149.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_11_2337",
  x1: 353.031,
  y1: 112.73,
  x2: 352.031,
  y2: 112.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_11_2337",
  x1: 356.031,
  y1: 151.108,
  x2: 348.031,
  y2: 151.108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_11_2337",
  x1: 212.088,
  y1: 112.73,
  x2: 211.088,
  y2: 112.73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AF92"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_11_2337",
  x1: 215.088,
  y1: 133.108,
  x2: 207.088,
  y2: 133.108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AF92"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_11_2337",
  x1: 252,
  y1: 94.1081,
  x2: 244,
  y2: 94.1081,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A862"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AF92"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_11_2337",
  x1: 252,
  y1: 108.108,
  x2: 244,
  y2: 108.108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E84747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})));

function SvgOrderbooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 223,
    viewBox: "0 0 550 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_2337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 47,
    width: 440,
    height: 128
  }, _ref2), _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderbooks);
export default __webpack_public_path__ + "static/media/Orderbooks.ecab04be6d6ef1bbf069f15848d07a8b.svg";
export { ForwardRef as ReactComponent };